import { AuthState } from '../auth/auth.types';
import { AdminState } from './admin.types';
import { ADMIN } from '../account/Constants';

export const isAdminAccount = (authState: AuthState): boolean =>
  authState.account && authState.account.accountType === ADMIN;

export const isImpersonating = (adminState: AdminState): boolean =>
  adminState !== undefined &&
    adminState.impersonation !== undefined && 
    adminState.impersonation.authToken !== '' &&
    adminState.impersonation.authToken !== undefined && 
    adminState.impersonation.account !== undefined;


// WEBPACK FOOTER //
// ./src/admin/Util.tsx